import { render, staticRenderFns } from "./slip.vue?vue&type=template&id=e15e42b4"
import script from "./slip.vue?vue&type=script&lang=js"
export * from "./slip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports